import Vue from "vue";
import Vuex from "vuex";
import User from "./modules/user";
import Tarm from "./modules/tarm";
import EmergencyCallLocal from "./modules/local/emergency_call"
import SearchAdress from "./modules/local/search_adress";
import Hospital from "./modules/hospital"
import Ambulance from "./modules/ambulance"
import NursingStaff from './modules/nursing_staff'
import VuexPersistence from "vuex-persist";
import Rules from "./modules/rules"
import AdminUsers from "./modules/admin-users"
import Bases from "./modules/bases"

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ["User"]
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    User,
    Tarm,
    SearchAdress,
    EmergencyCallLocal,
    Hospital,
    Ambulance,
    NursingStaff,
    Rules,
    AdminUsers,
    Bases,
  },
  state: {
    email: null,
    loader: false,
    alertError: {
      alert: false,
      message: ""
    }
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload;
    },
    setAlertError(state, payload) {
      state.alertError.alert = payload.alert;
      state.alertError.message = payload.message;
    },
    clearAlertError(state) {
      state.alertError = {
        alert: false,
        message: ""
      };
    }
  },
  actions: {
    SOCKET_newcall({ commit }, payload) {
      console.log("conectou com algo", payload, commit);
    }
  },
  getters: {
    loader(state) {
      return state.loader;
    },
    alertError(state) {
      return state.alertError;
    }
  }
});
